<script>
    export default {
        name: "ProductPrice",
        props: {
            oldPrice: Number,
            price: Number,
            discountCount: Number,
            isSmallSize: Boolean,
            isCardSize: Boolean,
            isPreOrder: Boolean,
            hideDiscountLabel: Boolean,
        },
        computed: {
            isDiscount() {
                return this.discountCount;
            },
        },
    };
</script>

<template>
    <div
        class="product-price"
        :class="{
            'product-price--sm': isSmallSize,
            'product-price--card': isCardSize,
            'product-price--preorder': isPreOrder,
        }"
    >
        <div class="product-price__wrap">
            <div
                class="product-price__number is-current"
                :class="{ 'is-discount': isDiscount }"
            >
                {{ price | formatPrice }}&nbsp;₽
            </div>
            <div v-if="isDiscount" class="product-price__number product-price__number--old">
                {{ oldPrice | formatPrice }}&nbsp;₽
            </div>
        </div>
        <div v-if="isDiscount && !hideDiscountLabel" class="product-price__label">
            -{{ discountCount }}%
        </div>
    </div>
</template>

<style lang="scss">
    .product-price {
        position: relative;
        display: flex;
        align-items: center;
    }

    .product-price__label {
        width: 48px;
        height: 22px;
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        background: var(--danger);
        color: #fff;
        border-radius: 50px;
        margin-left: 12px;
        text-align: center;

        @include bp($bp-desktop-sm) {
            width: 52px;
            height: 24px;
            font-size: 16px;
            line-height: 24px;
        }
    }

    .product-price__wrap {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
    }

    .product-price__number {
        font-weight: bold;
        font-size: 18px;
        line-height: 26px;
        color: #000000;
        &.is-current {
            margin-right: 8px;
        }
        &.is-discount {
            color: var(--danger-text);
        }
        @include bp($bp-desktop-sm) {
            font-size: 32px;
            line-height: 36px;
            &.is-current {
                margin-right: 20px;
            }
        }
    }

    //
    // --mod
    //

    .product-price__number--old {
        font-weight: 500;
        font-size: 14px;
        color: #acbccc;
        text-decoration: line-through;
        @include bp($bp-desktop-sm) {
            font-size: 16px;
        }
    }

    .product-price--preorder {
        .product-price__number {
            color: #acbccc;
        }
    }

    .product-price--sm {
        .product-price__number {
            font-size: 12px;
            line-height: 18px;
            &.is-current {
                margin-right: 8px;
            }
        }

        .product-price__number--old {
            font-size: 10px;
        }

        .product-price__label {
            font-size: 10px;
            width: 38px;
            height: 18px;
            line-height: 18px;
            margin-left: 10px;
        }
    }

    .product-price--card {
        .product-price__wrap {
            flex-direction: column-reverse;
            @include bp($bp-desktop-sm) {
                flex-direction: row;
            }
        }

        .product-price__number {
            font-size: 16px;
            font-weight: 700;
            line-height: 16px;
            @include bp($bp-desktop-sm) {
                font-size: 30px;
                line-height: 30px;
            }
        }

        .product-price__number--old {
            margin-bottom: 2px;
            font-size: 12px;
            font-weight: 500;
            line-height: 12px;
            @include bp($bp-desktop-sm) {
                margin-bottom: 0;
                font-size: 30px;
                line-height: 30px;
            }
        }
    }
</style>
